import { Box, SelectChangeEvent } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

function HealthcareSystemInput() {
  const [partOfHealthcareSystem, setPartOfHealthcareSystem] = useState<boolean | null>(null);

  const { partnerInfo, showErrors, partnerGroupInfo, updatePartnerInfo, updatePartnerGroupInfo } =
    useContext(PartnerIntakeContext);

  const handleHealthcareSystemChange = useCallback(
    (e: SelectChangeEvent) => {
      const updatedValue = (e.target as HTMLInputElement).value;
      const booleanValue = updatedValue === '1' ? true : updatedValue === '0' ? false : null;

      if (updatePartnerInfo && partnerInfo) {
        updatePartnerInfo({ ...partnerInfo, healthcareSystem: booleanValue });
      }

      if (booleanValue === true) {
        updatePartnerGroupInfo({ ...partnerGroupInfo, partnerName: null });
      }
    },
    [updatePartnerInfo, partnerInfo, updatePartnerGroupInfo, partnerGroupInfo]
  );

  useEffect(() => {
    if (partnerInfo?.healthcareSystem != partOfHealthcareSystem)
      setPartOfHealthcareSystem(partnerInfo?.healthcareSystem ?? null);
  }, [partnerInfo?.healthcareSystem, partOfHealthcareSystem]);

  return (
    <Box flexGrow={1}>
      <SelectInput
        id={'healthcare-system-select'}
        label={'Is your facility part of a healthcare system?'}
        value={
          partOfHealthcareSystem != null ? (partnerInfo.healthcareSystem ? 1 : 0).toString() : ''
        }
        hasError={showErrors && partOfHealthcareSystem == null}
        selectOptions={[
          { value: '1', label: 'Yes' },
          { value: '0', label: 'No' },
        ]}
        required
        onChange={handleHealthcareSystemChange}
      />
    </Box>
  );
}

export default HealthcareSystemInput;
